import { SET_DELIVERY_STATE, SET_IS_FETCHING_DELIVERY, SET_DELIVERY_STATUS, RESET_DELIVERY } from 'reducers/actions-types';

import { OPEN } from 'constants/order-states';

const initialDate = new Date().toISOString();

export default function deliveryReducer(state = {
    isFetching: false,
    hasFetched: false,
    now: initialDate,
    minDate: initialDate,
    maxDate: initialDate,
    date: initialDate,
    status: OPEN, // the 'state' property in the response, renamed due to ambiguity
}, { type, newState, isFetching, status }) {
    switch (type) {
        case SET_DELIVERY_STATUS:
            return Object.assign({}, state, { status });
        case SET_DELIVERY_STATE:
            return Object.assign({}, state, newState);
        case SET_IS_FETCHING_DELIVERY:
            return Object.assign({}, state, { isFetching });
        case RESET_DELIVERY:
            return Object.assign({}, state, { hasFetched: false });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/delivery/index.js